<template>
  <div>
    <div>
      <HeaderBreadcrumbs :items="[
      { label: 'Brands', to: '/brands' },
      { label: 'Edit' }
    ]" title="Edit Premium Offers" />
    </div>
    <div class="w-full p-4 rounded-lg bg-white shadow-sm">
      <div class="justify-between flex items-center mb-3">
        <div>
          <h3 class="text-xl font-bold mb-3"> Premium Offers</h3>
     
        </div>
        <div>
          <button 
          variant="primary"
          type="button" 
          :disabled="countPremium === 0"
  :class="[
    'px-2 py-2 border rounded-lg',
    countPremium === 0 ? 'bg-gray-300 text-white' : 'bg-blue-700 text-white'
  ]"
          @click="createAction">+ Add New</button>
        </div>
      </div>
      <div v-if='this.totalRows==0'>
        <div class="flex-col items-center justify-center flex-nowrap flex" style="height: 65vh;">
                    <svg class="w-16 h-16 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z"/>
</svg>

                    <h4 class="text-base text-gray-600 mb-0">No Data</h4>
                    <p class="text-sm text-gray-500">There are no data to display</p>
                              </div>
               
            </div>
          <Table 
          v-else
          :headers="headers" 
          :data="items" 
          :row-key="['premiumName', 'offerStatus','offerCode','createdOffer','modifiedOffer']"
          :current-page="currentPage" :isLoading="isLoading" :per-page="20">
          <template #offerStatus="{ value }">
          <div class="px-0 py-1 rounded-lg w-96 text-left capitalize">
           {{ getOffersStatus(value) }}
          </div>
        </template>
        <template #createdOffer="{ value }">
          <span>{{ formatDate(value).date }}</span>
          <br>
          <span class="italic text-xs">{{ formatDate(value).time }}</span>
        </template>       
        <template #modifiedOffer="{ value }">
          <span>{{ formatDate(value).date }}</span>
          <br>
          <span class="italic text-xs">{{ formatDate(value).time }}</span>
        </template>        
        <template #actions="{ row }">
          <button @click="deleteAction(row.premiumsId,row.premiumName)">
            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
              <path fill-rule="evenodd" d="M8.586 2.586A2 2 0 0 1 10 2h4a2 2 0 0 1 2 2v2h3a1 1 0 1 1 0 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a1 1 0 0 1 0-2h3V4a2 2 0 0 1 .586-1.414ZM10 6h4V4h-4v2Zm1 4a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Zm4 0a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Z" clip-rule="evenodd"/>
            </svg>
          </button>
        </template>
        </Table>
        </div>

<t-modal ref="modalDelete">
      <div class="text-sm flex-col w-full text-center">
        <label class="text-center font-semibold"> Please Check Again Before Continue </label>
      </div>
      <div>
        <p class="text-gray-500 text-xs">Are you sure you want to delete this "{{this.premiumName}}" ?</p>
      </div>
      <div class="flex justify-center">
        <button class="bg-blue-700 mr-2 border text-white p-1 px-2 rounded-lg ml-1 text-sm"
          @click="confirmSubmit">Delete</button>
        <button class=" bg-white text-gray-700 border p-1 px-2 rounded-lg mr-1 text-sm" @click="cancel">Cancel</button>
        
      </div>
    </t-modal>
    <t-modal ref="modalAdd">
      <div class="text-sm flex-col w-full text-left">
        <label class="text-center font-semibold"> Add Premium Offers </label>
      </div>
      <div class="mb-3">
        <p class="text-gray-500 text-xs">Premium Offers</p>
        <multiselect
                      placeholder="Enter Premiums Offer"
                      open-direction="bottom"
                      v-model="form.default_premium"
                      label="name"
                      track-by="name"
                      :options="premiumSearchOptions"
                      :loading="isPremiumSearch"
                      :searchable="true"
                      :close-on-select="true"
                      :options-limit="10"
                      :multiple="true"
                      @search-change="premiumFind">
                    </multiselect>
      </div>
      <div class="flex justify-end">
        <button class="bg-blue-700 mr-0 border text-white p-1 px-2 rounded-lg text-sm"
          @click="AddItemPremium">Add</button> 
      </div>
    </t-modal>

  </div>
  
</template>

<script>


import { mapState, mapActions } from 'vuex';
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';
import Table from '@/components/form/table.vue'
import moment from 'moment';
import { EventBus } from '../../../src/event-bus';

import constant from "../../store/constant";
export default {
  name: 'DisplayPremiumsPath',
  components: {
    HeaderBreadcrumbs,
    Table
  },
  data() {
    return {
      isLoadingSearch: false,
      items_search: [],
      debounce: null,
      id: null,
      currentPage: 1,
      premiumId:null,
      premiumName:null,
      perPage: 20,
      countPremium: null,
      form: {
        default_premium:[],
      },
      isPremiumSearch: false,
      premiumSearchOptions: [],
      headers: [
        { label: 'No', key: 'no' },
        { label: 'Premium Offers Name', key: 'premiumName' },
        { label: 'Offer Status', key: 'offerStatus' },
        { label:  'Offer Code',key:'offerCode' },
        { label: 'Created Date', key:'createdOffer'},
        { label: 'last modified', key:'modifiedOffer'},
        
      ],
      fields: [
        { key:'premiumName', label: 'Premiums Name'},
        { key:'offerStatus', label: 'Offer Status', formatter:function(value){
          if (value==constant.OFFER_STATUS.NEW){
            return 'NEW';
          }
          else if (value==constant.OFFER_STATUS.WAITING_FOR_REVIEW){
            return 'WAITING_FOR_REVIEW';
          }
          else if (value==constant.OFFER_STATUS.IN_REVIEW){
            return 'IN_REVIEW';
          }
          else if (value==constant.OFFER_STATUS.REJECTED){
            return 'REJECTED';
          }
          else if (value==constant.OFFER_STATUS.APPROVED){
            return 'APPROVED';
          }
          else if (value==constant.OFFER_STATUS.PREPARE_FOR_SALE){
            return 'PREPARE_FOR_SALE';
          }
          else if (value==constant.OFFER_STATUS.NOT_FOR_SALE){
            return 'READY_FOR_SALE';
          }
          else if (value==constant.OFFER_STATUS.NOT_FOR_SALE){
            return 'NOT_FOR_SALE';
          }else if(value==constant.OFFER_STATUS.READY_FOR_SALE){
            return 'Ready For Sale';
          } else {
            return value;
          }
        }},
        { key:'offerCode', label: 'Offer Code'},
        { key :'createdOffer', label:'Created (Offer)',formatter: function(value) {
            return moment(value).format('DD-MM-YYYY');
        },},
        { key :'modifiedOffer', label:'Modified (Offer)',formatter: function(value) {
            return moment(value).format('DD-MM-YYYY');
        },},
        { key:'delete-action', label: 'Delete'},
      ]
    };
  },
  computed: {
    ...mapState({
      totalRows: (state) => state.brands.totalRows,
      items :(state) => state.brands.items,
      isLoading : (state) => state.brands.isLoading,
      isError : (state) => state.brands.isError,
      message: (state) => state.brands.successMessage,
      isCreate: (state) => state.brands.isCreate,
      name: (state) => state.brands.name,
    }),
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title || 'Brands - Premiums | Content Management System Ebooks Gramedia.com';
      }
    },
    message : function () {
      if (!this.message) return;
      if (this.isError){
        console.log("ini error ",this.isError)
         EventBus.$emit('show-toast', {
            message: this.message,
            type: 'error',
          });
      }else{
        EventBus.$emit('show-toast', {
            message: 'Premium offers has been updated.',
            type: 'success',
          });
          this.actionGetBrandsPremiumsPremiums(); 
          this.setPremiumLimit() 
      }
      
    },
  },
  created() {
   this.actionGetBrandsPremiumsPremiums()
   this.setPremiumLimit() 
  },
  mounted() {
    this.actionGetBrandsPremiumsPremiums()
    this.setPremiumLimit() 
  },
  methods: {
...mapActions("brands", ["getPremiumsByBrandIdAdapter","getStatusItems","deletePremiums","searchPremium", "insertPremiums","getPremiumLimit"]),
    actionGetBrandsPremiumsPremiums() {
      this.id = this.$route.params.id;
      this.getPremiumsByBrandIdAdapter(this.id);
    },
    setPremiumLimit() {
    this.isPremiumSearch = true;
    let payload={
      id:this.$route.params.id,
    }
    this.getPremiumLimit(payload)
    .then((response) => {
      this.premiumSearchOptions = response.data.data.rows;
      this.countPremium = response.data.data.count
      this.isPremiumSearch = false;
    })
    .catch(() => {
      this.isPremiumSearch = false;
    });
  },
  premiumFind(query) {
    if (!query) return;
    this.isPremiumSearch = true;
    clearTimeout(this.debounce)
    this.debounce = setTimeout(() => {
      let payload={
        id:this.id,
        qry:query
      }
      this.searchPremium(payload)
      .then((response) => {
        this.premiumSearchOptions = response.data.data.rows;
        this.isPremiumSearch = false;
      }).catch(() => {
        this.isPremiumSearch = false;
      });
    }, 600);
  },
    createAction(e) {
      e.preventDefault();
      if(this.isCreate==false){
          EventBus.$emit('show-toast', {
            message: `Can’t add new Premium Offers, this brand’s item status is not “Ready for Consume”`,
            type: 'error',
          });
        }else{
          this.$refs.modalAdd.show();
        // this.$router.push({
        //   path: `/brands/createPremiums/${this.id}`,
        // });
      }
    },
    getOffersStatus(value) {
      const statusLabels = {
        [constant.OFFER_STATUS.NEW]: 'NEW',
        [constant.OFFER_STATUS.WAITING_FOR_REVIEW]: 'WAITING_FOR_REVIEW',
        [constant.OFFER_STATUS.IN_REVIEW]: 'IN_REVIEW',
        [constant.OFFER_STATUS.REJECTED]: 'REJECTED',
        [constant.OFFER_STATUS.APPROVED]: 'APPROVED',
        [constant.OFFER_STATUS.PREPARE_FOR_SALE]: 'PREPARE_FOR_SALE',
        [constant.OFFER_STATUS.NOT_FOR_SALE]: 'NOT_FOR_SALE',
        [constant.OFFER_STATUS.READY_FOR_SALE]: 'Ready For Sale'
      };

      return statusLabels[value] || value;
    },
    formatDate(tgl) {
      return {
        date: moment(tgl).format('DD MMM YY'),
        time: moment(tgl).format('HH:mm:ss')
      };
    },
    cancel() {
      this.$refs.modalDelete.hide();
    },
    async deleteAction(premiumId,premiumName) {
      this.premiumName = premiumName
      this.premiumId = premiumId
      this.$refs.modalDelete.show();
    },
    AddItemPremium() {
      const data = this.form;
      const payload = {
        id: this.id,
        default_premium: data.default_premium.map(item => item.id),
      }
      this.insertPremiums(payload);
      this.actionGetBrandsPremiumsPremiums(); 
       this.form.default_premium = []
      this.$refs.modalAdd.hide();
    },
    confirmSubmit() {
      this.$refs.modalDelete.hide();
      let payload={
              offer_id:this.premiumId,
              id:this.id,
            }
       this.deletePremiums(payload).then((response) => {
        if (response.result === 'Success') {
          EventBus.$emit('show-toast', {
            message: `Delete Success ${this.premiumName}`,
            type: 'success',
          });
          this.actionGetBrandsPremiumsPremiums()
          this.setPremiumLimit() 
      } 
          return response;
        })
        .catch((error) => {
          EventBus.$emit('show-toast', {
            message: `Failed Delete`,
            type: 'error',
          });
          return error;
        });
    },
    formatNumber(value) {
      if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return '0';
    },reset() {
      Object.assign(this.$data, this.$options.data.call(this));
    },
  }
};

</script>
<style scoped>
</style>
